import { MouseEventHandler, useEffect, useState } from 'react'

const useInIframe = () => {
  const [inIframe, setInIframe] = useState(false)

  useEffect(() => {
    setInIframe(window !== window.parent)
  }, [])

  // when in "embed" mode, this component lives inside an iframe,
  // so we want to navigate the parent window instead
  const handleOnClick: MouseEventHandler<HTMLAnchorElement> = (e) => {
    if (!inIframe) return

    const elem = e.currentTarget
    elem.setAttribute('target', '_blank')
  }

  return { inIframe, handleOnClick }
}

export default useInIframe
